(function () {
  var SUBSCRIPTION_SHIPPING_MIN = 50;
  var ONETIME_SHIPPING_MIN = 50;
  var REBUY_WAIT_MS = 200;
  var REBUY_WAIT_MAX = 50;
  var cartFetchInFlight = false;

  function itemsHaveSubscription(items) {
    if (!items || !items.length) return false;
    for (var i = 0; i < items.length; i++) {
      if (items[i] && items[i].selling_plan_allocation) return true;
    }
    return false;
  }

  function cartHasSubscription(shopifyCart) {
    var Cart = window.Rebuy && window.Rebuy.Cart;
    if (Cart && typeof Cart.cartHasSellingPlanSubscriptionItems === 'function') {
      try {
        if (Cart.cartHasSellingPlanSubscriptionItems()) return true;
      } catch (e) {}
    }
    if (Cart && Cart.cart && itemsHaveSubscription(Cart.cart.items)) return true;
    return itemsHaveSubscription(shopifyCart && shopifyCart.items);
  }

  function isShippingTier(tier) {
    return tier && (tier.type === 'shipping' || tier.type === 'free_shipping');
  }

  function collectShippingTiers(bar, tiers) {
    if (!bar || !bar.tiers || !bar.tiers.length) return;
    for (var i = 0; i < bar.tiers.length; i++) {
      if (isShippingTier(bar.tiers[i])) {
        tiers.push(bar.tiers[i]);
      }
    }
  }

  function collectFromProgressBar(progressBar, tiers) {
    if (!progressBar) return;
    if (Object.prototype.toString.call(progressBar.tiers) === '[object Array]') {
      collectShippingTiers(progressBar, tiers);
    } else if (Object.prototype.toString.call(progressBar) === '[object Array]') {
      for (var i = 0; i < progressBar.length; i++) {
        collectShippingTiers(progressBar[i], tiers);
      }
    } else if (progressBar.bars && progressBar.bars.length) {
      for (var j = 0; j < progressBar.bars.length; j++) {
        collectShippingTiers(progressBar.bars[j], tiers);
      }
    }
  }

  function getShippingTiers() {
    var tiers = [];
    var SmartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!SmartCart) return tiers;

    collectFromProgressBar(SmartCart.progressBar, tiers);
    if (SmartCart.settings) {
      collectFromProgressBar(SmartCart.settings.progressBar, tiers);
      collectFromProgressBar(SmartCart.settings.progress_bar, tiers);
    }

    if (typeof SmartCart.getProgressBarSettings === 'function') {
      try {
        collectFromProgressBar(SmartCart.getProgressBarSettings(), tiers);
      } catch (e) {}
    }
    if (typeof SmartCart.getBarForLocation === 'function') {
      try {
        collectFromProgressBar(SmartCart.getBarForLocation(), tiers);
      } catch (e) {}
    }

    return tiers;
  }

  function setShippingMinimum(minimum) {
    var SmartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!SmartCart) return;
    var tiers = getShippingTiers();
    for (var i = 0; i < tiers.length; i++) {
      tiers[i].minimum = minimum;
    }
    var settings = SmartCart.settings;
    if (settings && settings.free_shipping) {
      settings.free_shipping.minimum = minimum * 100;
    }
  }

  function applyThreshold(shopifyCart) {
    var SmartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!SmartCart) return;
    if (!shopifyCart || Object.prototype.toString.call(shopifyCart.items) !== '[object Array]') {
      shopifyCart = null;
    }

    var rebuyItems = window.Rebuy.Cart && window.Rebuy.Cart.cart && window.Rebuy.Cart.cart.items;
    if (!shopifyCart && !rebuyItems && !cartFetchInFlight) {
      cartFetchInFlight = true;
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          cartFetchInFlight = false;
          applyThreshold(cart);
        })
        .catch(function () {
          cartFetchInFlight = false;
          setShippingMinimum(ONETIME_SHIPPING_MIN);
        });
      return;
    }

    var minimum = cartHasSubscription(shopifyCart) ? SUBSCRIPTION_SHIPPING_MIN : ONETIME_SHIPPING_MIN;
    setShippingMinimum(minimum);
  }

  function shouldHideRebuyCart() {
    return document.body && document.body.classList.contains('tb-hide-rebuy-cart');
  }

  function suppressRebuyCart() {
    if (!shouldHideRebuyCart()) return;
    var SmartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (!SmartCart) return;
    SmartCart.skip_open = true;
    if (typeof SmartCart.hide === 'function') {
      try {
        SmartCart.hide();
      } catch (e) {}
    }
  }

  document.addEventListener('rebuy:cart.ready', applyThreshold);
  document.addEventListener('rebuy:cart.change', applyThreshold);
  document.addEventListener('rebuy:smartcart.show', applyThreshold);
  document.addEventListener('rebuy.loaded', applyThreshold);
  document.addEventListener('rebuy:smartcart.ready', suppressRebuyCart);
  document.addEventListener('rebuy:smartcart.show', function () {
    if (!shouldHideRebuyCart()) return;
    requestAnimationFrame(suppressRebuyCart);
  });

  function waitForRebuy() {
    if (window.Rebuy && window.Rebuy.SmartCart) {
      applyThreshold();
      suppressRebuyCart();
      return;
    }
    var attempts = 0;
    var id = setInterval(function () {
      attempts += 1;
      if ((window.Rebuy && window.Rebuy.SmartCart) || attempts >= REBUY_WAIT_MAX) {
        clearInterval(id);
        applyThreshold();
        suppressRebuyCart();
      }
    }, REBUY_WAIT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForRebuy, { once: true });
  } else {
    waitForRebuy();
  }
})();
